import api from './api';

const partService = {
  getPartsByModule: async (moduleId, params = {}) => {
    try {
      const response = await api.get(`/furniture-parts/${moduleId}/parts`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar peças:', error);
      throw error;
    }
  },

  getPartById: async (id) => {
    try {
      const response = await api.get(`/furniture-parts/parts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar peça:', error);
      throw error;
    }
  },

  createPart: async (moduleId, data) => {
    try {
      const response = await api.post(`/furniture-parts/${moduleId}/parts`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar peça:', error);
      throw error;
    }
  },

  updatePart: async (id, data) => {
    try {
      const response = await api.put(`/furniture-parts/parts/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar peça:', error);
      throw error;
    }
  },

  deletePart: async (id) => {
    try {
      const response = await api.delete(`/furniture-parts/parts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar peça:', error);
      throw error;
    }
  },

  getPartsByProject: async (projectId, params = {}) => {
    try {
      const response = await api.get(`/furniture-parts/project/${projectId}/parts`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar peças do projeto:', error);
      throw error;
    }
  }
};

export default partService;
